import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { Metamodel } from 'app/model/base/model';
import { CopySourceAdapter, commonCopySourceAdapts } from './copysource.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { PostgreSqlV2CopySource } from 'app/model/pipeline/copysource/postgre-sql-v2.copysource';
import { ValueAdapter } from '../../value.adapter';
import { isLogicAppExpression } from 'app/shared/utils/expression.util';
import { Duration } from 'luxon';
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(PostgreSqlV2CopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        query: '*',
        queryTimeout: '*'
    }
})
export class PostgreSqlV2CopySourceAdapter extends CopySourceAdapter<PostgreSqlV2CopySource, Model.PostgreSqlSource> {
    protected override async _toResource(copySource: PostgreSqlV2CopySource): Promise<Model.PostgreSqlSource> {
        const result: Model.PostgreSqlSource = this._toTabularResource(copySource, Metamodel.modelFor(PostgreSqlV2CopySource).name);
        try {
            result.queryTimeout =
                typeof copySource.queryTimeout === 'number'
                    ? Duration.fromObject({ minutes: copySource.queryTimeout }).toFormat('hh:mm:ss')
                    : ValueAdapter.toResource(copySource, PostgreSqlV2CopySource.QUERY_TIMEOUT);
        } catch {
            this._logError('Failed to convert PostgreSqlV2CopySource  queryTimeout into TimeSpan');
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.PostgreSqlSource,
        copyActivity: CopyActivity
    ): Promise<PostgreSqlV2CopySource> {
        const result: PostgreSqlV2CopySource = this._toTabularModel(resource, copyActivity, PostgreSqlV2CopySource.MODEL);

        try {
            if (resource.queryTimeout == null) {
                result.queryTimeout = undefined;
            } else {
                if (typeof resource.queryTimeout === 'string' && !isLogicAppExpression(resource.queryTimeout)) {
                    const parts = resource.queryTimeout.split(':');
                    if (parts.length === 3) {
                        const duration = Duration.fromObject({
                            hours: parseInt(parts[0], 10),
                            minutes: parseInt(parts[1], 10),
                            seconds: parseInt(parts[2], 10)
                        });
                        result.queryTimeout = duration.as('minutes');
                    } else {
                        this._logError('Failed to convert AzurePostgreSqlCopySource queryTimeout into number');
                    }
                } else {
                    ValueAdapter.toModel(result, PostgreSqlV2CopySource.QUERY_TIMEOUT, resource.queryTimeout);
                }
            }
        } catch {
            this._logError('Failed to convert AzurePostgreSqlCopySource queryTimeout into number');
        }

        return result;
    }
}
